// extracted by mini-css-extract-plugin
export var card = "qQrON";
export var phone = "ZZQGR";
export var phoneChrome = "LrpbD";
export var root = "bFD5f";